import { useState, useEffect } from "react";
import { fetchSheetData } from "./fetchSheetData";

export const useVideoData = (sheetId) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchSheetData(sheetId, "Videos!A1:C50");
        setData(data);
      } catch (e) {
        console.error("Error fetching videos", e.message);
      }
    };
    fetchData();
  }, [sheetId]);

  return data;
};
